import type { ReactNode } from 'react';
import { getStrings } from '@veylme/shared';

import { detectLocale } from '../i18n/detectLocale.js';
import { FallbackScreen } from './FallbackScreen.js';

/**
 * Английский фолбэк на случай, если подведут даже `getStrings`/`detectLocale`
 * (не должны — обе pure/try-catch-обёрнуты). Дословно повторяет
 * `err_not_in_telegram` из `packages/shared/src/i18n/en.ts`.
 */
const FALLBACK_TEXT = 'Mini App is not running in Telegram. Please restart the app.';

/**
 * Экран «приложение открыли вне Telegram» (work-039).
 *
 * Показывается вместо `<App/>`, когда `boot/bootSdk.ts` не смог поднять SDK:
 * без launch params всё дерево App нежизнеспособно (нет ни пропуска для API,
 * ни языка, ни темы), но белый экран — худший из возможных ответов человеку.
 *
 * Про язык: вне Telegram `language_code` взять неоткуда, `detectLocale()`
 * откатывается на `navigator.language`, а в худшем случае на 'en'. Это
 * нормально — экран одноразовый и никуда дальше не ведёт.
 *
 * Как и `ErrorBoundary`, рендерится СНАРУЖИ `App`, поэтому берёт строки
 * напрямую через `getStrings(detectLocale())`, а не через `useT()`:
 * `LocaleProvider` живёт внутри `App` и здесь недоступен.
 */
export function NotInTelegramScreen(): ReactNode {
  let text: string = FALLBACK_TEXT;
  try {
    text = getStrings(detectLocale()).err_not_in_telegram;
  } catch {
    // Остаёмся на английском фолбэке — надёжность важнее локализации.
  }
  return <FallbackScreen title={text} />;
}
